export const statuses = [
  {
    label: 'Actief',
    value: true,
  },
  {
    label: 'Inactief',
    value: false,
  },
]